import types from '../types'
import axios from 'axios'
import { getApiServer } from '../../utils/helpers'
import encounterStatusEnum from '../../utils/encounterStatusEnum'

const serverURL = getApiServer()

export const getPatient = () => async (dispatch) => {
  dispatch({ type: types.GET_PATIENT_REQUESTED })
  try {
    const patient = await axios.get(serverURL + '/api/patient', { withCredentials: true })
    dispatch({ type: types.GET_PATIENT_FULFILLED, payload: patient.data })
  } catch (error) {
    dispatch({ type: types.GET_PATIENT_REJECTED, payload: error })
  }
}

export const getEncounter = () => async (dispatch, getState) => {
  const { patient: { patient }, healthSystem: { healthSystem } } = getState()
  dispatch({ type: types.GET_ENCOUNTER_REQUESTED })
  try {
    const lupusEncounter = await axios.post(serverURL + '/api/encounter', { patientId: patient.patientId, healthSystemId: healthSystem.healthSystemId }, { withCredentials: true })
    dispatch({ type: types.GET_ENCOUNTER_FULFILLED, payload: lupusEncounter.data })
  } catch (error) {
    dispatch({ type: types.GET_ENCOUNTER_REJECTED, payload: error })
  }
}

export const startEncounterOver = () => async (dispatch, getState) => {
  const { patient: { encounter } } = getState()
  dispatch({ type: types.START_ENCOUNTER_OVER_REQUESTED })
  try {
    dispatch(updateSessionStatus(encounterStatusEnum.CREATED.value))
    const details = await axios.delete(serverURL + '/api/details', { data: { encounterId: encounter.encounterId } })
    dispatch({ type: types.START_ENCOUNTER_OVER_FULFILLED, payload: { details } })
  } catch (error) {
    dispatch({ type: types.START_ENCOUNTER_OVER_REJECTED, payload: error })
  }
}

export const resetPatient = () => async (dispatch, getState) => {
  const { patient: { patient } } = getState()
  dispatch({ type: types.RESET_PATIENT_REQUESTED })
  try {
    const reset = await axios.delete(serverURL + '/api/reset', { data: { patient: patient.patientId } })
    dispatch({ type: types.RESET_PATIENT_FULFILLED, payload: { reset } })
  } catch (error) {
    dispatch({ type: types.RESET_PATIENT_REJECTED, payload: error })
  }
}

export const getConditions = () => async (dispatch, getState) => {
  const { patient: { patient, encounter } } = getState()
  dispatch({ type: types.GET_PATIENT_CONDITIONS_REQUESTED })
  try {
    const savedConditons = await axios.get(serverURL + '/api/condition', { params: { patientId: patient.patientId, encounterId: encounter.encounterId }, withCredentials: true })
    dispatch({ type: types.GET_PATIENT_CONDITIONS_FULFILLED, payload:  savedConditons.data })
  } catch (error) {
    dispatch({ type: types.GET_PATIENT_CONDITIONS_REJECTED, payload: error })
  }
}

export const getProcedures = () => async (dispatch, getState) => {
  const { patient: { encounter, patient } } = getState()
  dispatch({ type: types.GET_PATIENT_PROCEDURES_REQUESTED })
  try {
    const savedProcedures = await axios.get(serverURL + '/api/procedure', { params: { encounterId: encounter.encounterId, patientId: patient.patientId }, withCredentials: true })
    dispatch({ type: types.GET_PATIENT_PROCEDURES_FULFILLED, payload: savedProcedures.data })
  } catch (error) {
    dispatch({ type: types.GET_PATIENT_PROCEDURES_REJECTED, payload: error })
  }
}

export const getObservations = () => async (dispatch, getState) => {
  const { patient: { encounter, patient } } = getState()
  dispatch({ type: types.GET_PATIENT_OBSERVATIONS_REQUESTED })
  try {
    const savedObservations = await axios.get(serverURL + '/api/observation', { params: { encounterId: encounter.encounterId, patientId: patient.patientId }, withCredentials: true })
    dispatch({ type: types.GET_PATIENT_OBSERVATIONS_FULFILLED, payload: savedObservations.data })
  } catch (error) {
    dispatch({ type: types.GET_PATIENT_OBSERVATIONS_REJECTED, payload: error })
  }
}

export const getMedications = () => async (dispatch, getState) => {
  const { patient: { encounter, patient } } = getState()
  dispatch({ type: types.GET_PATIENT_MEDICATIONS_REQUESTED })
  try {
    const medications = await axios.get(serverURL + '/api/medication', { params: { encounterId: encounter.encounterId, patientId: patient.patientId }, withCredentials: true })
    dispatch({ type: types.GET_PATIENT_MEDICATIONS_FULFILLED, payload: medications.data })
  } catch (error) {
    dispatch({ type: types.GET_PATIENT_MEDICATIONS_REJECTED, payload: error })
  }
}

export const updateSessionStatus = (status) => async (dispatch, getState) => {
  const { patient: { encounter } } = getState()
  try {
    const encounterStatus = await axios.put(serverURL + '/api/encounter-status', { encounterStatusId: encounter.status.encounterStatusId, status })
    dispatch({ type: types.UPDATE_ENCOUNTER_STATUS, payload: encounterStatus.data })
  } catch (error) {
    dispatch({ type: types.UPDATE_ENCOUNTER_STATUS, payload: error })
  }
}
